import { signedFetch } from './client';

export interface QueryInput {
  stores: string[];
  filter?: Record<string, unknown>;
  groupBy?: string;
  aggregate?: Record<string, { $count?: true; $sum?: string; $avg?: string }>;
  orderBy?: Record<string, 'asc' | 'desc'>;
  limit?: number;
  cursor?: string;
}

export interface QueryResult {
  results: Record<string, unknown>[];
  count: number;
  truncated: boolean;
  cursor?: string;
  esql?: string;
}

export async function runQuery(query: QueryInput): Promise<QueryResult> {
  const { data } = await signedFetch('POST', '/query', query);
  return data as QueryResult;
}

export async function runEsql(query: string): Promise<QueryResult> {
  const { data } = await signedFetch('POST', '/query/esql', { query });
  return data as QueryResult;
}

export async function generateEsql(prompt: string, stores: string[]): Promise<{ esql: string } & QueryResult> {
  const { data } = await signedFetch('POST', '/query/generate-esql', { prompt, stores });
  return data as { esql: string } & QueryResult;
}
